module.exports = {"apiKey":"AIzaSyCLbYBMX8aBr9ph4_LXXcinyob-Do4y4d0","firebase":{"apiKey":"AIzaSyCLbYBMX8aBr9ph4_LXXcinyob-Do4y4d0","authDomain":"bpmbuild-development.firebaseapp.com","databaseURL":"https://bpmbuild-development.firebaseio.com","projectId":"bpmbuild-development","storageBucket":"bpmbuild-development.appspot.com","messagingSenderId":"333509637104","appId":"1:333509637104:web:1cd558f387bebe7bcd6335"}}


//////////////////
// WEBPACK FOOTER
// ./src/common/config/Files/production.json
// module id = 1445
// module chunks = 0